import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeOfDayService {

  timeOfDay() {
    const now = new Date();
    const hours = now.getHours();
    if (hours < 4 || hours >= 17) {
      return $localize`Godaften`;
    } else if (hours >= 4 && hours < 10) {
      return $localize`Godmorgen`;
    } else if (hours >= 10 && hours < 17) {
      return $localize`Goddag`;
    }
    return '';
  }
}
